import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import styles from "../productPageStyle.js";

const useStyles = makeStyles(styles);

/**
 * The roman numeral, the title and an optional right-hand aside, on one
 * baseline. The numeral sits in a fixed-width lane so every section head, every
 * ledger row and every process step share the same left edge — the lane is what
 * makes the page read as a register rather than a stack of cards.
 *
 * `title` may be a string or, where one word carries different styling, nodes.
 */
export default function SectionHead({ num, title, aside, accent }) {
  const classes = useStyles();

  return (
    <div className={classes.sectionHead}>
      <span
        className={`${classes.sectionNum}${
          accent ? " " + classes.sectionNumRed : ""
        }`}
      >
        {num}
      </span>
      <h2 className={classes.sectionTitle}>{title}</h2>
      {aside && <span className={classes.sectionAside}>{aside}</span>}
    </div>
  );
}
